import React, { HTMLAttributes } from "react";
import StyledLogo from "./Logo.styled";
import LogoSvg from "../../../../public/images/origyn-foundation-black.svg";

const Logo = (props: HTMLAttributes<HTMLImageElement>) => (
  <StyledLogo {...props} src={LogoSvg} alt="Origyn logo" />
);

export default Logo;
